import {
    LOAD_NOTIFICATIONS,
    LOAD_NOTIFICATIONS_SUCCESS,
    LOAD_NOTIFICATIONS_FAILURE,
    LOAD_NOTIFICATIONS_COUNTERS_SUCCESS,
    OPEN_NOTIFICATIONS,
    CLOSE_NOTIFICATIONS,
} from '../actions';

const initialState = {
    meta: {
        status: null,
        status_code: null,
        previous: null,
        count: null,
        next: null,
    },
    fetching: false,
    error: undefined,
    content: [],
    show: false,
    total_unread_messages: 0,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_NOTIFICATIONS:
            return {
                ...state,
                fetching: true,
            };
        case OPEN_NOTIFICATIONS:
            return {
                ...state,
                show: true,
            };
        case LOAD_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                fetching: false,
                error: undefined,
                content: action.payload.content,
                meta: action.payload.meta,
            };
        case LOAD_NOTIFICATIONS_FAILURE:
            return {
                ...state,
                error: action.payload,
                fetching: false,
            };
        case LOAD_NOTIFICATIONS_COUNTERS_SUCCESS:
            return {
                ...state,
                total_unread_messages:
                    action.payload.content.total_unread_messages,
            };
        case CLOSE_NOTIFICATIONS:
            return {
                ...state,
                show: false,
            };
        default:
            return state;
    }
};

export default reducer;
